import { useTranslation } from 'react-i18next'
import { IconType } from 'react-icons'
import { useNavigate } from 'react-router-dom'
import { FaQuestion, FaRegUser } from "react-icons/fa";
import { signOut } from '../../services/auth'
import { useAppDispatch } from '../../store'
import { signOutUser } from '../../store/slice/auth'
import { FaRegCommentAlt } from "react-icons/fa";
import { FaPowerOff } from "react-icons/fa";




interface UserMenuItem {
  href: string | null
  label: string
  Icon: IconType
  handleClick: () => void
}

interface UserMenuProps {
  closeMenu: () => void
  openCookieModal: () => void
}

// Define a function to get the userMenu array
export const useUserMenu = ({ closeMenu, openCookieModal }: UserMenuProps) => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const dispatch = useAppDispatch()

  // Sign out and navigate to login page
  const handleSignOut = () => {
    signOut()
    dispatch(signOutUser())
    closeMenu()
    navigate('/')
  }

  return [
    {
      href: '/account',
      label: t('myAccount'),
      Icon: FaRegUser,
      handleClick: closeMenu,
    },
    // {
    //   href: '/billing',
    //   label: t('myBilling'),
    //   Icon: BillingIcon,
    //   handleClick: closeMenu,
    // },
    // {
    //   href: null,
    //   label: t('cookiePreferences'),
    //   Icon: FaSlidersH,
    //   handleClick: openCookieModal,
    // },
    {
      href: 'https://waslat.app/faq',
      label: t('faq'),
      Icon: FaQuestion,
      handleClick: closeMenu,
    },
    {
      href: null,
      label: t('signOut'),
      Icon: FaPowerOff,
      handleClick: handleSignOut,
    },
  ] as UserMenuItem[]
}
